import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-bank',
  standalone: false,
  templateUrl: './payment-bank.component.html',
  styleUrl: './payment-bank.component.scss'
})
export class PaymentBankComponent {

}
